export default __webpack_public_path__ + "static/media/modesp03.bb1fced5.png";